// 言語設定の一元管理
export const SUPPORTED_LANGUAGES = {
  ja: {
    code: 'ja',
    name: '日本語',
    shortName: 'JP',
    flag: '🇯🇵',
    fontClass: 'font-body',
    headingFontClass: 'font-heading',
    logo: 'jp',
    showRecruit: true, // 採用情報を表示するかどうか
    direction: 'ltr',
    region: 'Asia/Tokyo',
  },
  en: {
    code: 'en',
    name: 'English',
    shortName: 'EN',
    flag: '🇺🇸',
    fontClass: 'font-heading',
    headingFontClass: 'font-heading',
    logo: 'en',
    showRecruit: false,
    direction: 'ltr',
    region: 'America/New_York',
  },
  'zh-CN': {
    code: 'zh-CN',
    name: '简体中文',
    shortName: 'CN',
    flag: '🇨🇳',
    fontClass: 'font-chinese',
    headingFontClass: 'font-heading-chinese',
    logo: 'zh',
    showRecruit: false,
    direction: 'ltr',
    region: 'Asia/Shanghai',
  },
  'zh-TW': {
    code: 'zh-TW',
    name: '繁體中文（台灣）',
    shortName: 'TW',
    flag: '🇹🇼',
    fontClass: 'font-chinese-traditional',
    headingFontClass: 'font-heading-chinese-traditional',
    logo: 'zh',
    showRecruit: false,
    direction: 'ltr',
    region: 'Asia/Taipei',
  },
  'zh-HK': {
    code: 'zh-HK',
    name: '繁體中文（香港）',
    shortName: 'HK',
    flag: '🇭🇰',
    fontClass: 'font-chinese-traditional',
    headingFontClass: 'font-heading-chinese-traditional',
    logo: 'zh',
    showRecruit: false,
    direction: 'ltr',
    region: 'Asia/Hong_Kong',
  },
  ko: {
    code: 'ko',
    name: '한국어',
    shortName: 'KR',
    flag: '🇰🇷',
    fontClass: 'font-korean',
    headingFontClass: 'font-heading-korean',
    logo: 'en', // ロゴは英語版を使用
    showRecruit: false,
    direction: 'ltr',
    region: 'Asia/Seoul',
  },
  th: {
    code: 'th',
    name: 'ไทย',
    shortName: 'TH',
    flag: '🇹🇭',
    fontClass: 'font-thai',
    headingFontClass: 'font-heading-thai',
    logo: 'en',
    showRecruit: false,
    direction: 'ltr',
    region: 'Asia/Bangkok',
  },
  id: {
    code: 'id',
    name: 'Indonesian',
    shortName: 'ID',
    flag: '🇮🇩',
    fontClass: 'font-indonesian',
    headingFontClass: 'font-heading-indonesian',
    logo: 'en',
    showRecruit: false,
    direction: 'ltr',
    region: 'Asia/Jakarta',
  },
  vi: {
    code: 'vi',
    name: 'Tiếng Việt',
    shortName: 'VI',
    flag: '🇻🇳',
    fontClass: 'font-vietnamese',
    headingFontClass: 'font-heading-vietnamese',
    logo: 'en',
    showRecruit: false,
    direction: 'ltr',
    region: 'Asia/Ho_Chi_Minh',
  },
  es: {
    code: 'es',
    name: 'Español',
    shortName: 'ES',
    flag: '🇪🇸',
    fontClass: 'font-spanish',
    headingFontClass: 'font-heading-spanish',
    logo: 'en',
    showRecruit: false,
    direction: 'ltr',
    region: 'Europe/Madrid',
  },
  fr: {
    code: 'fr',
    name: 'Français',
    shortName: 'FR',
    flag: '🇫🇷',
    fontClass: 'font-french',
    headingFontClass: 'font-heading-french',
    logo: 'en',
    showRecruit: false,
    direction: 'ltr',
    region: 'Europe/Paris',
  },
  it: {
    code: 'it',
    name: 'Italiano',
    shortName: 'IT',
    flag: '🇮🇹',
    fontClass: 'font-italian',
    headingFontClass: 'font-heading-italian',
    logo: 'en',
    showRecruit: false,
    direction: 'ltr',
    region: 'Europe/Rome',
  },
  de: {
    code: 'de',
    name: 'Deutsch',
    shortName: 'DE',
    flag: '🇩🇪',
    fontClass: 'font-german',
    headingFontClass: 'font-heading-german',
    logo: 'en',
    showRecruit: false,
    direction: 'ltr',
    region: 'Europe/Berlin',
  },
};

// 言語コードの配列
export const LANGUAGE_CODES = Object.keys(SUPPORTED_LANGUAGES);

// デフォルト言語
export const DEFAULT_LANGUAGE = 'ja';

// ブラウザ言語から対応言語を検出する関数
export const detectBrowserLanguage = () => {
  const browserLang = navigator.language;
  if (/^zh-(?:hk|mo|hant-(?:hk|mo))(?:-|$)/i.test(browserLang)) {
    return 'zh-HK';
  }

  if (browserLang.startsWith('ja')) {
    return 'ja';
  } else if (/^zh-(?:tw|hant)(?:-|$)/i.test(browserLang)) {
    return 'zh-TW';
  } else if (browserLang.startsWith('zh')) {
    return 'zh-CN';
  } else if (browserLang.startsWith('ko')) {
    return 'ko';
  } else if (browserLang.startsWith('th')) {
    return 'th';
  } else if (browserLang.startsWith('id')) {
    return 'id';
  } else if (browserLang.startsWith('vi')) {
    return 'vi';
  } else if (browserLang.startsWith('es')) {
    return 'es';
  } else if (browserLang.startsWith('fr')) {
    return 'fr';
  } else if (browserLang.startsWith('it')) {
    return 'it';
  } else if (browserLang.startsWith('de')) {
    return 'de';
  } else {
    return 'en';
  }
};

// 言語設定を取得する関数
export const getLanguageConfig = languageCode => {
  return (
    SUPPORTED_LANGUAGES[languageCode] || SUPPORTED_LANGUAGES[DEFAULT_LANGUAGE]
  );
};

// 言語の配列を取得する関数（LanguageDropdownで使用）
export const getLanguagesArray = () => {
  return Object.values(SUPPORTED_LANGUAGES);
};

// Language URLs stay compatible with the existing single-page corporate site.
export const getLanguageUrl = (languageCode, baseUrl) => {
  const url = new URL(baseUrl);
  if (languageCode === DEFAULT_LANGUAGE) url.searchParams.delete('lang');
  else url.searchParams.set('lang', languageCode);
  return url.href;
};
export const getUrlLanguage = () => {
  const requested = new URLSearchParams(window.location.search).get('lang');
  return LANGUAGE_CODES.includes(requested) ? requested : null;
};
